import { render } from "./IndexLayout.vue?vue&type=template&id=fc0a4094&scoped=true"
import script from "./IndexLayout.vue?vue&type=script&lang=js"
export * from "./IndexLayout.vue?vue&type=script&lang=js"

import "./IndexLayout.vue?vue&type=style&index=0&id=fc0a4094&scoped=true&lang=css"

import exportComponent from "/home/misserver/Documents/akred/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc0a4094"]])

export default __exports__